import { render, staticRenderFns } from "./vehicleUpdationFailed.vue?vue&type=template&id=4033ca87"
import script from "./vehicleUpdationFailed.vue?vue&type=script&lang=js"
export * from "./vehicleUpdationFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports